import * as React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {Button, Panel, Row, Col} from "react-bootstrap";
import {size, first} from "lodash";
import "react-dates/lib/css/_datepicker.css";
import "font-awesome/less/font-awesome.less";
import "hint.css/hint.css";

import {HotelAction, placeOrder} from "../actions/hotels";
import {ApplicationState} from "../reducers";
import "./styles/hotels.less";
import {Order} from "../models/order";
import Cart from "./Cart";
import {PackageTotals} from "./PackageTotals";

interface Props extends RouteComponentProps<any> {
    order: Order;
    loading: boolean;
    errorMessage: string;
    placeOrder(order: Order): Promise<HotelAction>;
}

class Review extends React.Component<Props> {

    componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        if (nextProps.order && nextProps.order.paymentInfo && !nextProps.order.paymentInfo.ccNum) {
            this.props.history.push("/checkout");
            return;
        }
    }

    public render(): JSX.Element {
        return <div className="hotel-listing-c">
            <div className="package-container">
                <div className="checkout">
                    {this.renderCart()}
                </div>
            </div>
        </div>;
    }

    public renderCart(): JSX.Element {
        if (!this.props.order || !this.props.order.newUser || !this.props.order.paymentInfo) {
            return null;
        }
        const user = this.props.order.newUser;
        const {shippingAddress, billingAddress, billingSameAsShipping} = this.props.order;
        const info = this.props.order.paymentInfo;

        return (
            <Panel bsStyle="primary" className="cart">
                <Panel.Heading>Your Order Summary</Panel.Heading>
                <Panel.Body>
                    <Cart/>
                    <h3>Payment Info</h3>
                    <Row>
                        <Col xs={12} lg={9} className="payment-info">
                            <Col xs={12} lg={4} className="line">
                                <label>Shipping Address</label>
                                <div>
                                    <div>{user.firstName} {user.lastName}</div>
                                    <div>{shippingAddress.address1} {shippingAddress.address2}</div>
                                    <div>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip}</div>
                                    <div>{shippingAddress.country}</div>
                                </div>
                            </Col>

                            {billingSameAsShipping ? null : (
                                <Col xs={12} lg={4} className="line">
                                    <label>Billing Address</label>
                                    <div>
                                        <div>{billingAddress.address1} {billingAddress.address2}</div>
                                        <div>{billingAddress.city}, {billingAddress.state} {billingAddress.zip}</div>
                                        <div>{billingAddress.country}</div>
                                    </div>
                                </Col>
                            )}
                            <Col xs={12} lg={4} className="line">
                                <label>Card</label>
                                <div>
                                    <div>{this.sanitize(info.ccNum)} ({info.cardType})</div>
                                    <div>Expires: {info.expMonth}/{info.expYear}</div>
                                    <div>Billing zip code: {info.zipCode}</div>
                                </div>
                            </Col>
                        </Col>
                    </Row>
                    <h3>Totals</h3>
                    <PackageTotals order={this.props.order}/>
                    <Row>
                        <Col xs={12} style={{textAlign: "right"}}>
                            <Button bsStyle="default"
                                    style={{marginRight: "15px"}}
                                    onClick={() => this.props.history.push("/checkout")}>Edit Payment Info</Button>
                            <Button bsStyle="success"
                                    onClick={() => this.submitOrder()}>Submit Order</Button>
                        </Col>
                    </Row>
                </Panel.Body>
            </Panel>
        );
    }

    private sanitize(ccNum: string): string {
        const len = ccNum.length;
        if (len < 4) {
            return ccNum;
        }
        const last4 = ccNum.substr(ccNum.length - 4);
        const rest = "*".repeat(len - 4);
        return rest + last4;
    }

    private submitOrder() {
        this.props.placeOrder(this.props.order)
            .then(action => {
                if (action.validationError || this.props.errorMessage) {
                    this.props.history.push("/checkout");
                } else {
                    this.props.history.push("/confirm");
                }
            });
    }
}

const connected = connect((state: ApplicationState) => ({
    order: state.hotels.order,
    errorMessage: state.hotels.errorMessage,
    loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading
}), {
    placeOrder
})(Review);

export default withRouter<any>(connected);



// WEBPACK FOOTER //
// ./src/components/Review.tsx